import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { LiveChatVisitor, LiveChatVisitorList } from '@nucleus-commerce/api-client/admin';

import { liveVisitorsQueryOptions, visitorsRefetchMs } from './live-visitors-query';

/**
 * Whether the shopper of an open thread is on the storefront now: their row in the store's live
 * visitor list (patched by `visitor.updated`), matched by visitor, or by customer for a shopper
 * signed in on another device. `null` once loaded and not there.
 */
export function useVisitorPresence(
  storeId: string,
  visitorId: string | null,
  customerId: string | null,
  polling: boolean,
) {
  const select = useCallback(
    (list: LiveChatVisitorList): LiveChatVisitor | null =>
      list.items.find(
        (item) => item.id === visitorId || (customerId !== null && item.customerId === customerId),
      ) ?? null,
    [visitorId, customerId],
  );
  return useQuery({
    ...liveVisitorsQueryOptions(storeId),
    refetchInterval: visitorsRefetchMs(polling),
    enabled: visitorId !== null || customerId !== null,
    select,
  });
}
